import { Reducer } from 'redux';

import {
    PAGEHEADER_FETCH_FLAGGED_COUNTS_SUCCESS,
    PAGEHEADER_FETCH_SUCCESS, PageHeaderFetchFlaggedCountsSuccessAction,
    PageHeaderFetchSuccessAction,
} from 'mk2/containers/PageHeader/PageHeader.action';
import { tupdate } from 'mk2/helpers/types';
import { PageHeaderUserData } from 'mk2/schemas';

export interface PageHeaderState {
    userData: PageHeaderUserData;
    brandDays: BrandDaysData;
    feedMenu: FeedItem[] | FeedGroup[];
}

export interface BrandDaysData {
    activeViralCampaign: ViralCampaignData;
    logoDesktopWidth: number;
    logoDesktopHeight: number;
    logoMobileWidth: number;
    logoMobileHeight: number;
}

export interface FeedGroup {
    isGroup: boolean;
    name: string;
    title: string;
    items: FeedItem[];
    icon: string;
    url: string;
    lastVisitCount: string;
    mobile: boolean;
}

export interface FeedItem {
    isGroup: boolean;
    name: string;
    title: string;
    items?: FeedItem[];
    icon: string;
    url: string;
    lastVisitCount: string;
    mobile: boolean;
}

export type MenuItem = FeedGroup | FeedItem;

interface ViralCampaignData {
    title: string;
    logoPrefix: string;
    logoUrl: string;
    logoHomepageImg: string;
}

const userDataInitialState: PageHeaderUserData = {
    commentsCount: 0,
    heartsCount: 0,
    unreadMails: 0,
    newBazaarEvents: 0,
    newBazaarSell: 0,
    allBazaarSell: 0,
    wallStatusNews: 0,
    wishlistUpdates: 0,
    groupsCount: 0,
};

const brandDaysInitialState: BrandDaysData = {
    activeViralCampaign: null,
    logoDesktopWidth: 0,
    logoDesktopHeight: 0,
    logoMobileWidth: 0,
    logoMobileHeight: 0,
};

const pageHeaderInitialState: PageHeaderState = {
    userData: userDataInitialState,
    brandDays: brandDaysInitialState,
    feedMenu: null,
};

declare type PageHeaderReducerAction =
    | PageHeaderFetchSuccessAction
    | PageHeaderFetchFlaggedCountsSuccessAction;

export const pageHeaderReducer: Reducer<PageHeaderState> = (state: PageHeaderState = pageHeaderInitialState, action: PageHeaderReducerAction) => {
    switch (action.type) {
        case PAGEHEADER_FETCH_SUCCESS:
            return tupdate(state, {
                userData: action.data,
            });
        case PAGEHEADER_FETCH_FLAGGED_COUNTS_SUCCESS:
            if (state.feedMenu && state.feedMenu.length > 0) {
                let idxFlagged: number;
                let idxFlaggedGroups: number;
                Object.keys(state.feedMenu).forEach((k) => {
                    if (state.feedMenu[k].name === 'flagged') {
                        idxFlagged = parseInt(k, 10);
                    }
                    if (state.feedMenu[k].name === 'flagged-groups') {
                        idxFlaggedGroups = parseInt(k, 10);
                    }
                });
                if (idxFlagged !== undefined && idxFlaggedGroups !== undefined) {
                    let newFeedMenu = [...state.feedMenu];
                    newFeedMenu = [
                        ...newFeedMenu.slice(0, idxFlagged),
                        tupdate(newFeedMenu[idxFlagged], {lastVisitCount: action.flaggedCount.toString()}),
                        ...newFeedMenu.slice(idxFlagged + 1),
                    ];
                    newFeedMenu = [
                        ...newFeedMenu.slice(0, idxFlaggedGroups),
                        tupdate(newFeedMenu[idxFlaggedGroups], {lastVisitCount: action.flaggedGroupCount.toString()}),
                        ...newFeedMenu.slice(idxFlaggedGroups + 1),
                    ];
                    return tupdate(state, {
                        feedMenu: newFeedMenu,
                    });
                }
            }
            return state;

        default:
            return state;
    }
};

// export const getShow = (state: PageHeaderState, menuId: string) => state[menuId] && state[menuId].show;
